import * as React from "react";
import Button from "@mui/material/Button";

// This used to render a dropdown caret in front of a commented-out menu (ADO 319). The menu's
// three items were not "this page" vs "all records", as everyone remembered -- they were per-tab
// download variants, each gated on the tab you were already on, so only ever one was visible and
// it did what the button already did. The caret promised a choice that never existed.
//
// US-176 settled what the download means: it exports exactly what the tab is showing, which now
// includes the All tab's "include expired and cancelled" checkbox. The filter is the choice, so
// there is nothing left to put behind a caret.
const AgreementSyncDownloadButton = ({ onDownload, disabled }) => (
  <Button
    color="primary"
    sx={{ mb: 1 }}
    variant="contained"
    onClick={() => onDownload()}
    disabled={disabled}
  >
    Download
  </Button>
);

export default AgreementSyncDownloadButton;
